import React from "react";

import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
 
const containerStyle = {

  width: "100%",

  height: "500px",

};
 
// Center the map (between two offices)

// const center = { lat: 22.7376, lng: 74.8279 };
const center = { lat: 23.2, lng: 76.2 };
 
// Office locations

const officeLocations = [

  { lat: 26.91217294984601, lng: 75.74351745349941, name: "Akinex Office - Jaipur , Navajyoti, 2nd Floor, Corner Plot, Vaishali Nagar, Jaipur, Rajasthan - 302021" },

  { lat: 18.56294315940313, lng: 73.91219654103183, name: "Akinex Office - Pune , 202, Platinum Square, Next to Hyatt Regency, Pune, Maharashtra - 411014" },

  { lat: 21.140417, lng: 79.065889, name: "Akinex Office - 1st Floor, Yashoda Complex, Gadaga, Nagpur, Maharashtra - 440010" },

];
 
// Function to open Google Maps with directions

const openGoogleMaps = (lat, lng) => {

  const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

  window.open(url, "_blank");

};
 
const GoogleMapSection = () => {

  return (
<LoadScript googleMapsApiKey="AIzaSyDOpIJdNOOB2r5u-3BtVW5vNTgEjH-53vI">
<GoogleMap mapContainerStyle={containerStyle} center={center} zoom={6}>

        {officeLocations.map((office, index) => (
<Marker

            key={index}

            position={{ lat: office.lat, lng: office.lng }}

            title={office.name}

            onClick={() => openGoogleMaps(office.lat, office.lng)} // Click to open Google Maps

          />

        ))}
</GoogleMap>
</LoadScript>

  );

};
 
export default GoogleMapSection;
//  import React from "react";

// const GoogleMapIframe = () => {
//   return (
//     <div style={{ width: "100%", height: "600px" }}>
//       <iframe
//        src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d30148336.62039793!2d56.498468513161306!3d22.720179166901524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f12!2m1!1sAkinex!5e0!3m2!1sen!2sin!4v1758630919060!5m2!1sen!2sin"
//         width="100%"
//         height="100%"
//         style={{ border: 0 }}
//         allowFullScreen=""
//         loading="lazy"
//         referrerPolicy="no-referrer-when-downgrade"
//         title="Google Map"
        
        
//       ></iframe>
//     </div>
//   );
// };

// export default GoogleMapIframe;
